import { Component, OnInit, Input, Output, EventEmitter, ViewChild, ElementRef, AfterViewInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import * as _moment from 'moment/moment';
import { Reg } from 'src/app/shared/reg.model';
import { RegService } from 'src/app/shared/Reg.Service';
import { Resp } from 'src/app/shared/resp.model';
import * as textMask from 'vanilla-text-mask/dist/vanillaTextMask.js';
import { MatDatepickerInputEvent } from '@angular/material/datepicker';
import { AppInsightsService } from 'src/app/shared/AppInsights.Service';

@Component({
  selector: 'app-step-one',
  templateUrl: './step-one.component.html',
  styleUrls: ['./step-one.component.scss'],
})
export class StepOneComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() emitter: EventEmitter<string> = new EventEmitter();
  public isCes: boolean = false;
  public isEqh: boolean = false;
  public type: string;
  public showPlaceholder: boolean;
  public show = false;
  @Input() userid = '';
  @Input() govid = '';
  @Input() email = '';
  public pasteData = '';
  public step1 = false;
  public step2 = false;
  public isLoading = false;
  error: boolean;
  message: any;
  policyShow: boolean = true;
  isAutoRegValid: boolean = false;
  public dob: Date;
  public resp: Resp;
  public uuid: string;
  public validate = true;
  public minDate = new Date(1900, 0, 1);
  public maxDate = new Date(2020, 11, 31);
  public isMonth = false;
  public isDay = false;
  public isYear = false;
  public formErrorFields: any = {
    emailReq: false,
    emailVal: false,
    govidReq: false,
    dobReq: false
  };
  show401kText: boolean;
  view: string;
  caseId: string;
  utm_source: string;
  utm_medium: string;
  utm_campaign: string;
  utm_content: string;
  constructor(
    public regService: RegService,
    private activatedRoute: ActivatedRoute,
    private appInsightsService: AppInsightsService,
    private router: Router
  ) {
  	this.activatedRoute.queryParams.subscribe(params => {
      this.email = !!params["email"] ? params["email"] : "";
      this.caseId = !!params["caseid"] ? params["caseid"] : "";
      this.utm_source = !!params["utm_source"] ? params["utm_source"] : "";
      this.utm_medium = !!params["utm_medium"] ? params["utm_medium"] : "";
      this.utm_campaign = !!params["utm_campaign"] ? params["utm_campaign"] : "";
      this.utm_content = !!params["utm_content"] ? params["utm_content"] : "";
      this.view = !!params["view"] ? params["view"] : "Life/Investment";
      console.log(params);
    });
    
  	if(this.router.url.indexOf('/ces') !== -1){
      this.isCes = true;
    }else{
      this.isEqh = true;
    }
  }

  mask = [/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]; // mm/dd/yyyy
  ssnmask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]; // 000-00-0000
  maskedInputController;

  @ViewChild('em') public em: ElementRef;
  @ViewChild('policy') public policy: ElementRef;
  @ViewChild('input') public input: ElementRef;
  @ViewChild('ssn') public ssnInput: ElementRef;

  ngOnInit() {
  	window.scroll(0, 0);
    this.type = 'password'; // display as '*'
    this.showPlaceholder = true;
    this.generateSession();
    this.appInsightsService.logEvent("Client Registration UI Step One");

    if (this.view === "retirement") {
      this.show401kText = true;
    } else {
      this.show401kText = false;
    }
  }

  ngAfterViewInit(): void {
    setTimeout(() => {
      this.maskedInputController = textMask.maskInput({
        inputElement: this.input.nativeElement,
        mask: this.mask,
        guide: false
      });
      this.maskedInputController = textMask.maskInput({
        inputElement: this.ssnInput.nativeElement,
        mask: this.ssnmask,
        guide: false
      });
    });
  }

  ngOnDestroy() {
    this.maskedInputController.destroy();
  }
  accpetNumericOnly(event) {
    const e = event as KeyboardEvent;
    if ([46, 8, 9, 27, 13, 110, 190].indexOf(e.keyCode) !== -1 ||
      // Allow: Ctrl+A
      (e.keyCode === 65 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+C
      (e.keyCode === 67 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+V
      (e.keyCode === 86 && (e.ctrlKey || e.metaKey)) ||
      // Allow: Ctrl+X
      (e.keyCode === 88 && (e.ctrlKey || e.metaKey)) ||
      // Allow: home, end, left, right
      (e.keyCode >= 35 && e.keyCode <= 39)) {
      // let it happen, don't do anything
      return;
    }
    // Ensure that it is a number and stop the keypress
    if ((e.shiftKey || (e.keyCode < 48 || e.keyCode > 57)) && (e.keyCode < 96 || e.keyCode > 105)) {
      e.preventDefault();
    }
  }

  openDate(datePicker){
    datePicker.open();
    this.dob= null;
    (document.getElementById("dpicker") as HTMLInputElement).value = '';
  }

  addEvent(event: MatDatepickerInputEvent<Date>) {
  	this.validateForm('dob');
  }

  focusOnInput() {
    let setError = false;
    if (!!this.formErrorFields.emailReq || !!this.formErrorFields.emailVal) {
      setError = true;
      setTimeout(() => this.em.nativeElement.focus(), 0);
      setTimeout(() => this.em.nativeElement.select(), 0);
      window.scrollTo(0,this.em.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    } else if (!!this.formErrorFields.govidReq || !!this.formErrorFields.govidVal) {
      setError = true;
      setTimeout(() => this.ssnInput.nativeElement.focus(), 0);
      setTimeout(() => this.ssnInput.nativeElement.select(), 0);
      window.scrollTo(0,this.ssnInput.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    } else if (!!this.formErrorFields.dobReq) {
      setError = true;
      setTimeout(() => this.input.nativeElement.focus(), 0);
      setTimeout(() => this.input.nativeElement.select(), 0);
      window.scrollTo(0,this.input.nativeElement.getBoundingClientRect().top + window.scrollY - 150);
    }

    return setError;
  }

  isErrorPresent() {
    if (!this.formErrorFields.emailReq && !this.formErrorFields.emailVal
      && !this.formErrorFields.govidReq && !this.formErrorFields.govidVal && !this.formErrorFields.dobReq) {
      return false;
    } else {
      return true;
    }
  }

  validateAllFields() {
    const fields = ['email', 'govid', 'dob'];
    let isErrPresent = false;
    for (let j = 0; j < fields.length; j++) {
    	if (fields[j] === 'dob') {
    		let dobVal =(document.getElementById("dpicker") as HTMLInputElement).value;
    		isErrPresent = !this.isDatePattern(dobVal) ? true : false;
		      if (isErrPresent) {
		      	this.formErrorFields.dobReq = true;
		        break;
		      }
    	} else {
    		isErrPresent = this.validateForm(fields[j]);
		      if (isErrPresent) {
		        break;
		      }
    	}
    }
    return isErrPresent;
  }

  ifAtleastOneFieldValidated(model) {
    this.validate = !!this[model] ? false : true;
    return this.validate;
  }

  validateForm(model) {
    let error = false;
    this.validate = true;

    if (model === 'email') {
      if (!this.email || this.email === undefined) {
        this.formErrorFields.emailReq = true;
        this.formErrorFields.emailVal = false;
        error = true;
      } else if (this.emailCheck()) {
        this.formErrorFields.emailReq = false;
        this.formErrorFields.emailVal = true;
        error = true;
      } else {
        this.formErrorFields.emailReq = false;
        this.formErrorFields.emailVal = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }

    if (model === 'govid') {
      if (!this.govid || this.govid === undefined) {
        this.formErrorFields.govidReq = true;
        this.formErrorFields.govidVal = false;
        error = true;
      } else if (this.govid !== '' && this.govid.replace(/[- ()]/g, '').length !== 9) {
        this.formErrorFields.govidReq = false;
        this.formErrorFields.govidVal = true;
        error = true;
      } else {
        this.formErrorFields.govidReq = false;
        this.formErrorFields.govidVal = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }

    if (model === 'dob') {
      const isOpen = document.getElementsByClassName('mat-datepicker-popup').length === 0 ? false : true;
      if (isOpen) { return; }
      let textDate = (document.getElementById("dpicker") as HTMLInputElement).value;
      if (textDate === "") {
      	this.isMonth = this.isDay = this.isYear = false;
      	this.formErrorFields.dobReq = false;
        this.ifAtleastOneFieldValidated(model);
      } else if (!this.isValidDate(textDate)) {
        this.formErrorFields.dobReq = true;
        error = true;
      } else {
        this.formErrorFields.dobReq = false;
        this.ifAtleastOneFieldValidated(model);
      }
    }

    console.log(this.formErrorFields);
    if (!!this.email && !!this.govid && !!this.dob && !this.isErrorPresent() && !error) {
      this.validate = error;
    }
    return error;
  }

  isDatePattern(dateString) {
	// First check for the pattern
	if(/^\d{1,2}\/\d{1,2}\/\d{4}$/.test(dateString)) {
		return true;
	}
  }


  //Validates that the input string is a valid date formatted as "mm/dd/yyyy"
  isValidDate(dateString) {
	    // Parse the date parts to integers
	    let isValid = false;
	    let parts = dateString.split("/");
	    let month = parseInt(parts[0], 10);
	    let day = parseInt(parts[1], 10);
	    let year = parseInt(parts[2], 10);

		// Check the ranges of month
	    if (!isNaN(month)) {
	    	if(month > 12) {
	    		this.isMonth = false;
	    	} else {
	    		this.isMonth = true;
		    }
	    }

	    // Check the ranges of day
	    if (!isNaN(day)) {
	    	let monthLength = [ 31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31 ];

		    // Adjust for leap years
		    if(year % 400 == 0 || (year % 100 != 0 && year % 4 == 0)) {
		    	monthLength[1] = 29;
		    }

		    // Check the range of the day
		    if(day <= monthLength[month - 1]) {
		    	this.isDay = true;
		    } else {
		    	this.isDay = false;
		    }
	    }

	    // Check the ranges of year
	    if (!isNaN(year)) {
	    	if (year.toString().length === 1) {
	    		if(parseInt(year.toString().charAt(0)) === 1 || parseInt(year.toString().charAt(0)) === 2) {
	    			this.isYear = true;
		    	} else {
			    	this.isYear = false;
			    }
	    	}
	    	if (year.toString().length === 2) {
	    		if((parseInt(year.toString().charAt(0)) === 1 || parseInt(year.toString().charAt(0)) === 2) &&
	    			(parseInt(year.toString().charAt(1)) === 9 || parseInt(year.toString().charAt(1)) === 0)) {
	    			this.isYear = true;
		    	} else {
			    	this.isYear = false;
			    }
	    	}
	    	if (year.toString().length === 3) {
	    		if((parseInt(year.toString().charAt(0)) === 1 || parseInt(year.toString().charAt(0)) === 2) &&
	    			(parseInt(year.toString().charAt(1)) === 9 || parseInt(year.toString().charAt(1)) === 0) &&
	    			(parseInt(year.toString().charAt(2)) >= 0 || parseInt(year.toString().charAt(2)) <= 9)) {
	    			this.isYear = true;
		    	} else {
			    	this.isYear = false;
			    }
	    	}
	    	if (year.toString().length === 4) {
	    		if(year < 1900 || year > new Date().getFullYear()) {
	    			this.isYear = false;
		    	} else {
			    	this.isYear = true;
			    }
	    	}
	    }

	    if ((/^\d{1,2}$/.test(dateString) || /^\d{1,2}\/$/.test(dateString)) && this.isMonth) {
	    	isValid = true;
	    }

	    if ((/^\d{1,2}\/\d{1,2}$/.test(dateString) || /^\d{1,2}\/\d{1,2}\/$/.test(dateString)) && this.isMonth && this.isDay) {
	    	isValid = true;
	    }

	    if (/^\d{1,2}\/\d{1,2}\/\d{1,4}$/.test(dateString) && this.isMonth && this.isDay && this.isYear) {
	    	isValid = true;
	    }

	    if (this.formErrorFields.dobReq && !this.isDatePattern(dateString)){
  			return false;
  		} else {
  			return isValid;
  		}

  };

  numberOnly(event) {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);
    if (event.keyCode !== 8 && !pattern.test(inputChar)) {
      return event.preventDefault();
    }
    return true;
  }

  emailCheck() {
    const regex = /^(([^<>()\[\]\\.,;:\s@"*~]+(\.[^<>()\[\]\\.,;:\s@"*~]+)*)|(".+"))@((([a-zA-Z0-9\-]+\.)+[a-zA-Z0-9]{2,10}))$/;
    if (!regex.test(this.email)) {
      return true;
    } else {
      return false;
    }
  }

  toggleShow() {
    this.show = !this.show;
    if (this.show) {
      this.type = 'text';
    } else {
      this.type = 'password';
    }
  }
  setPlaceholder(ele) {
    if (this.showPlaceholder) {
      ele.setAttribute('placeholder', ele.getAttribute('data-placeholder'));
    } else {
      ele.setAttribute('placeholder', '');
    }
  }

  togglePlaceholder(event: FocusEvent) {
    this.showPlaceholder = !this.showPlaceholder;
    this.setPlaceholder(event.target);
  }

  toggleForm(event: FocusEvent, model) {
    this.showPlaceholder = !this.showPlaceholder;
    this.setPlaceholder(event.target);
    this.validateForm(model);
  }

  paste(event: ClipboardEvent) {
    if (event && event.clipboardData) {
      this.pasteData = event.clipboardData.getData('text');
    }
  }

  continue() {

    if (!this.validateAllFields()) {
      window.scroll(0, 0);
      this.validate = true;
      const reg = new Reg();
      if (this.dob) {
        reg.axaDOB = _moment(this.dob).format('MM/DD/YYYY');
      }
      reg.axassn = this.govid.replace(/[- ()]/g, '');
      reg.newEmail = this.email;
      reg.sessionId = this.uuid;
	  reg.autoRegValid = this.isAutoRegValid;
	  reg.isCes = this.isCes;
	  reg.caseId = this.caseId;
	  reg.utm_source = this.utm_source;
	  reg.utm_medium = this.utm_medium;
	  reg.utm_campaign = this.utm_campaign;
	  reg.utm_content = this.utm_content;
      if (this.pasteData === this.govid) {
        reg.ssnPasteEvent = 'Yes';
      } else {
        reg.ssnPasteEvent = 'No';
      }

      const bodyString = JSON.stringify(reg);
      setTimeout(() => {
        this.error = false;
        this.isLoading = true;
        this.message = '';
        this.validate = true;
      });
      this.regService.regStepOne(bodyString).subscribe(res => {
        this.resp = res;
        if (this.resp && this.resp !== undefined && Object.keys(this.resp).length > 0) {
          setTimeout(() => {
            this.isLoading = false;
          });
          if (this.resp.status_code !== '200') {
            this.validate = false;
            if (this.resp.status_code === '303' && this.resp.url) {
              console.log('url ' + this.resp.url);
              window.location.href = this.resp.url;
            } else {
              window.scroll(0, 0);
              this.error = true;
              if (this.resp.message) {
                this.message = this.resp.message;
              } else {
                this.message = 'Session has expired please close browser and try again';
              }
              setTimeout(() => {
              	  this.maskedInputController = textMask.maskInput({
			        inputElement: this.input.nativeElement,
			        mask: this.mask,
			        guide: false
			      });
			      this.maskedInputController = textMask.maskInput({
			        inputElement: this.ssnInput.nativeElement,
			        mask: this.ssnmask,
			        guide: false
			      });
			    });
            }
          } else {
            console.log('url ' + this.resp.url);
            window.location.href = window.location.origin + this.resp.url;
          }
        }
      });
    } else {
      this.focusOnInput();
    }
  }

  generateSession() {
    let dt = new Date().getTime();
    this.uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,
      function(c) {
        const r = (dt + Math.random() * 16) % 16 | 0; dt = Math.floor(dt / 16); return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });
    console.log('session: ' + this.uuid);
  }
}
